import mappingActionTypes from './MappingConstants';
import {  UPDATE_FILE_INFORMATION_SUCCESS } from 'redux/files/FilesConstants';
import { EXCEL_FILE, getFileTypeCategory } from '../../shared/helpers/fileTransferHelper';
import { RESET_PROFILE, SET_PROFILE_FOR_EDITION } from '../profiles/ProfilesConstants';

const initialStore = {
  activeDivision: 0,
  showColumnLists: false,
  mappedFields: [],
  tempMappedFields: [],
  tempMappedFieldsInDivision: [],
  backupMappedFields: []
};

const MappingReducer = (state = initialStore, action) => {
  let mappedFields = [];
  let mappedFieldsInDivision = [];
  switch (action.type) {
    case mappingActionTypes.FETCH_IMPORT_MAPPING_DATA_SUCCESS:
      return { ...state, showColumnLists: true };
    case mappingActionTypes.RESET_IMPORT_MAPPING_DATA_SUCCESS:
      return { ...initialStore, showColumnLists: getFileTypeCategory(action.fileExtension) === EXCEL_FILE };
    case mappingActionTypes.SET_MAPPED_FIELD: // eslint-disable-line no-case-declarations
      const { targetField, sourceField, subGroup, prevValue, activeDivision } = action;
      mappedFields = [ ...state.tempMappedFields.filter(mappedField => mappedField.targetField !== prevValue)];
      targetField ? mappedFields.push({ targetField, sourceField, subGroup, activeDivision }) : '';
      mappedFieldsInDivision = [ ...state.tempMappedFieldsInDivision.filter(mappedFieldInDivision => mappedFieldInDivision.targetField !== prevValue)];
      targetField ? mappedFieldsInDivision.push({ targetField, sourceField, subGroup, activeDivision }) : '';
      return {
        ...state,
        tempMappedFieldsInDivision: mappedFieldsInDivision,
        tempMappedFields: mappedFields
      };
    case mappingActionTypes.SET_ACTIVE_DIVISION:
      return { ...state, activeDivision: action.division };
    case UPDATE_FILE_INFORMATION_SUCCESS:
      return { ...state, showColumnLists: getFileTypeCategory(action.fileInformation.fileExtension) === EXCEL_FILE };
    case mappingActionTypes.BACKUP_MAPPED_FIELDS:
      return { ...state, backupMappedFields: state.mappedFields.map(e => ({ ...e }))};
    case mappingActionTypes.RESTORE_MAPPED_FIELDS:
      return {
        ...state,
        mappedFields: state.backupMappedFields.map(e => ({ ...e })),
        tempMappedFields: state.backupMappedFields.map(e => ({ ...e }))
      };
    case SET_PROFILE_FOR_EDITION:
      return {
        ...state,
        showColumnLists: true,
        mappedFields: action.mappedFields.map(e => ({ ...e })),
        backupMappedFields: action.mappedFields.map(e => ({ ...e }))
      };
    case RESET_PROFILE:
      return { ...initialStore };
    case mappingActionTypes.RESET_MAPPED_FIELDS_IN_DIVISION:
      return { 
        ...state, 
        tempMappedFields: state.tempMappedFields.filter( tempMappedField => 
          !state.tempMappedFieldsInDivision.find( tempDivisionField => 
            tempMappedField.targetField === tempDivisionField.targetField
          )
        ),
        tempMappedFieldsInDivision: []
      };
    case mappingActionTypes.LOADED_MAPPED_FIELDS_DIVISION:
      return { ...state, tempMappedFieldsInDivision: [ ...state.mappedFields.filter(field => field.activeDivision === action.division)] };
    case mappingActionTypes.LOADED_MAPPED_FIELDS:
      return { ...state, tempMappedFields: [ ...state.mappedFields] };
    case mappingActionTypes.ADD_DIVISION_MAP_TO_MAPPING:
      return {
        ...state, mappedFields: [
          ...state.mappedFields.filter(field => field.activeDivision !== action.division).map(e => ({ ...e })),
          ...state.tempMappedFieldsInDivision.map(e => ({ ...e }))
        ]
      };
    default:
      return state;
  }
};

export default MappingReducer;



// WEBPACK FOOTER //
// ./src/redux/mapping/MappingReducer.js